import React from "react";
import ReactDOM from "react-dom";
import App from "./containers/App";
import "./styles/App.css";
import "bootstrap/dist/css/bootstrap.min.css"; //react bootstrap import

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
